import plantaSvg from "../../../assets/svgFeatures/Plantas.svg";

interface FeatureCardProps {
  title: string;
  description: string;
  backgroundColor: string;
  svg?: string;
}
export const FeatureCardComponent = ({
  title,
  description,
  backgroundColor,
  svg = plantaSvg,
}: FeatureCardProps) => {
  return (
    <div className="feature text-center is-revealing">
      <div className="feature-inner">
        <div className="feature-icon" style={{ background: backgroundColor }}>
          <img src={svg} style={{ clipPath: "border-box" }} />
        </div>
        <h4 className="feature-title h3-mobile mb-8">{title}</h4>
        <p className="text-sm">{description}</p>
      </div>
    </div>
  );
};
